import React from 'react';
import LOOKUP from 'constants/lookup';
import VisibilityIcon from '@mui/icons-material/Visibility';
// Basic Components
import Button from 'screens/components/basic/Button';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "HourlySales";

const Header = ({ showBody, download }) => (
    <CardSimple className="p-1">
        <div className="row row_margin_none">
            <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.selectedDate.name}
                    floatingLabelText={LOOKUP.report.common.selectedDate.label + "*"}
                    hintText={LOOKUP.report.common.selectedDate.label + "*"}
                    fullWidth={true}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-4">
                <BranchSelectAutoCompleteInput
                    name={componentName + LOOKUP.report.common.branchName}
                    label={LOOKUP.report.common.branch + "*"}
                />
            </div> {/* .col */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 mt-1 mb_xs p-0">
                <Button
                    type="IconInButton"
                    className="pull-right mt-2 ml-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={showBody}
                />
                <Button
                    type="DownloadButton"
                    className="pull-right mt-2 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.downloadReport.name}
                    label={LOOKUP.report.common.downloadReport.label}
                    onTouchTap={download}
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <p className='purpleText'><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders' net sale value will be used in this report.</i></strong></p>
            </div>
        </div>
    </CardSimple>
);

export default Header;
